import React from 'react';

import dayjs from 'dayjs';
import styled from 'styled-components';

import { useEditSwotDataModalContext } from './EditSwotDataModalContext';

const StyledContainer = styled.div`
  display: flex;
  flex-flow: column;
  margin-bottom: 5px;
`;

const StyledHistoryDataContainer = styled.div`
  margin-bottom: 10px;
`;

const StyledTitle = styled.div`
  font-size: 14px;
  font-family: var(--font-bold);
  color: var(--text-primary);
`;

const StyledUser = styled.div`
  font-size: 14px;
  font-family: var(--font-regular);
`;

const StyledDate = styled.div`
  font-family: var(--font-regular);
  color: var(--text-secondary);
  font-size: 12px;
`;

const SwotHistory = () => {
  const { temporarySwotState } = useEditSwotDataModalContext();

  const created = dayjs(temporarySwotState?.created_at);
  const updated = dayjs(temporarySwotState?.updated_at);

  return (
    <>
      {temporarySwotState?.created_at && (
        <StyledContainer>
          <StyledHistoryDataContainer>
            <StyledTitle>Added By</StyledTitle>
            <StyledUser>{temporarySwotState?.created_by_full_name}</StyledUser>
            <StyledDate>{dayjs(temporarySwotState?.created_at).format('MMM DD YYYY')}</StyledDate>
          </StyledHistoryDataContainer>
          {updated.diff(created, 'second') > 0 && (
            <StyledHistoryDataContainer>
              <StyledTitle>Last Updated By</StyledTitle>
              <StyledUser>{temporarySwotState?.updated_by_full_name}</StyledUser>
              <StyledDate>{dayjs(temporarySwotState?.updated_at).format('MMM DD YYYY')}</StyledDate>
            </StyledHistoryDataContainer>
          )}
        </StyledContainer>
      )}
    </>
  );
};

export default SwotHistory;
